export default __webpack_public_path__ + "static/media/admin.2da02a22.svg";